<template>
  <div class="sidebar-content">
    <div class="close-icon-wrapper">
      <div @click="$closeSidebar">
        <DiscardIcon class="close"/>
      </div>
    </div>
    <div class="sidebar-content__header-wrapper">
      <div class="sidebar-content__headline">Hilfe</div>
    </div>

    <div class="sidebar-content__sub-headline">Eskalationszeitraum</div>

    <p>Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Morbi leo risus, porta ac
      consectetur ac, vestibulum at eros. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Nulla
      vitae elit libero, a pharetra augue. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Curabitur
      blandit tempus porttitor. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. </p>
    <p>Aenean eu leo quam.
      Pellentesque ornare sem lacinia quam venenatis vestibulum. Morbi leo risus, porta ac consectetur ac, vestibulum at
      eros. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Nulla vitae elit libero, a pharetra
      augue. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Curabitur blandit tempus porttitor.
      Integer posuere erat a ante venenatis dapibus posuere velit aliquet.</p>

    <div class="sidebar-content__header-wrapper">
      <div class="sidebar-content__headline">Weitere Themen</div>
    </div>
    <div class="sidebar-content__links">
      <a>Marktplätze erstellen </a>
      <a>Gruppen erstellen </a>
      <a>Eskalationszeitraum einstellen</a>
      <a>Sales Pipeline konfigurieren</a>
    </div>
  </div>
</template>

<script>
import DiscardIcon from "@/components/icons/DiscardIcon";

export default {
  name: "SideBarExample",
  components: {DiscardIcon},
  setup() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.sidebar-content {
  margin-left: 16px;
  margin-right: 16px;
  padding: 44px 0;

  .close-icon-wrapper {
    cursor: pointer;
    display: inline-block;
    margin-left: -5px;

    .close {
      width: 44px;
      height: 44px;
      padding: 5px;
    }
  }

  &__header-wrapper {
    padding-top: 40px;
    padding-bottom: 16px;
    border-bottom: 1px solid map-get($grey, 'darken-1');
  }

  &__headline {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
  }

  &__sub-headline {
    color: map-get($green, 'darken-1');
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    margin-top: 32px;
    margin-bottom: 16px;
  }

  p {
    color: map-get($grey, 'dark');
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 9px;
  }

  &__links {
    margin-top: 16px;

    a {
      display: block;
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
    }
  }
}
</style>

<style lang="scss">
.sidebar-content {
  .close-icon-wrapper {
    .close {
      .a, .b {
        stroke: map-get($grey, 'lighten-1');
      }

      &:hover {
        .a, .b {
          stroke: $icon-hover;
        }
      }
    }
  }
}
</style>
